/**
 * Anzeigename einer Vorlage.
 *
 * Vorlagen haben einen technischen `name` (snake_case/lowercase, z.B.
 * "erstkontakt_begruessung") und optional einen frei gesetzten `title`
 * („Erstkontakt Begrüßung"). Diese reine Funktion liefert den besten
 * menschenlesbaren Namen: bevorzugt `title`, sonst eine hübsch aufbereitete
 * Form des technischen `name` (Unterstriche/Bindestriche → Leerzeichen,
 * jeder Wortanfang groß).
 */
export function templateDisplayName(t: { title?: string | null; name: string }): string {
  const title = t.title?.trim();
  if (title) return title;
  return prettifyName(t.name);
}

/** Macht aus einem technischen Namen einen Titel: Trenner → Space, Wortanfänge groß. */
function prettifyName(name: string): string {
  const words = (name ?? '')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return words
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
